export interface StartFreeSpinsPopupOptions {
  startByButton?: boolean;
  startBySpace?: boolean;
  stopBackgroundSoundOnStart?: boolean;
  stopBackgroundSoundOnAdd?: boolean;
  useFreeSpinMode?: boolean;
  useViewUpdater?: boolean;
  spinsCountSceneId?: string;
  startButtonSceneId?: string;
  freeSpinsStateName?: string;
  freeSpinsAddStateName?: string;
  closeStateName?: string;
  showRecovery?: boolean;
  showFreeSpinsAdd?: boolean;
  freeSpinsRecoveryStateName?: string;
  playButtonClickSound?: boolean;
}

export const START_FREE_SPINS_DEFAULT_OPTIONS: StartFreeSpinsPopupOptions = {
  spinsCountSceneId: 'freespin_text',
  startButtonSceneId: 'btnStart',
  freeSpinsStateName: 'freespins',
  freeSpinsAddStateName: 'freespins_add',
  freeSpinsRecoveryStateName: 'freespins_recovery',
  closeStateName: 'close',
  showFreeSpinsAdd: true,
};
